import Paths from '@/common/paths';
import request from '@/utils/request';

import type {
  CreatePlaceUtilityReq,
  FetchPlaceUtilityResp,
  PlaceUtilityDataType,
  UpdatePlaceUtilityReq,
} from './placeUtility.data';

export async function createPlaceUtility(params: CreatePlaceUtilityReq) {
  return request.post(`${Paths.PLACE_UTILITIES_API}`, {
    data: params,
  });
}

export async function fetchPlaceUtilities(params?: any): Promise<FetchPlaceUtilityResp> {
  return request.get(`${Paths.PLACE_UTILITIES_API}`, {
    params,
  });
}

export async function getPlaceUtilityDetail(id: string): Promise<PlaceUtilityDataType> {
  return request.get(`${Paths.PLACE_UTILITIES_API}/${id}`);
}

export async function updatePlaceUtility(id: string, params: UpdatePlaceUtilityReq) {
  return request.patch(`${Paths.PLACE_UTILITIES_API}/${id}`, {
    data: params,
  });
}

export async function deletePlaceUtility(id: string) {
  return request.delete(`${Paths.PLACE_UTILITIES_API}/${id}`);
}
